import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewContainerRef, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { AgentStatus } from 'src/app/models/agents/agent-status';
import { Instance, AVAILABLE_STATE_ICON, ENVIRONMENT_STATUS_ICON, ENV_PROGRESS_STATUS } from 'src/app/models/instance/instance';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { MatDialog } from '@angular/material/dialog';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Constants } from 'src/app/models/constants';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Types } from 'src/app/models/service/schedule';
import { Router, ActivatedRoute } from '@angular/router';
import { RedirectionDialogComponent } from 'src/app/components/redirection-dialog/redirection-dialog.component';
import { Overlay, OverlayRef, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import { Observable, Subscription, interval, combineLatest } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { CobService } from 'src/app/services/api/cob.service';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { UserService } from 'src/app/services/api/user.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { formatAvailabilityState, toUtcString } from 'src/app/services/util/utils';
import { ActivityService } from 'src/app/services/api/activity.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { EnvironmentActivityDetails } from '../environment-details/environment-activity-details/environment-activity-details';
import { InstancePollingService } from 'src/app/services/util/instance-polling.service';
const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_PII,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_PII,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_DELETE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_NONPII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_NONPII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_PII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_PII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.CONFIGURATION_READ,
    action: Permissions.CONFIGURATION_READ,
  },
  {
    key: PermissionKeys.INSTANCE_CREATE,
    action: Permissions.INSTANCE_CREATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ,
  },
  {
    key: PermissionKeys.BLUEPRINT_UPDATE,
    action: Permissions.BLUEPRINT_UPDATE,
  },
  {
    key: PermissionKeys.BLUEPRINT_DELETE,
    action: Permissions.BLUEPRINT_DELETE,
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_PII,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_UPDATE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE,
    action: Permissions.INSTANCE_AGENT_MANAGE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.INSTANCE_START_NONPII,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.INSTANCE_START_PII,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.INSTANCE_START_LIVE,
    name: Feature.INSTANCE_START,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
  {
    key: FeatureKeys.INSTANCE_STOP_NONPII,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.INSTANCE_STOP_PII,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.INSTANCE_STOP_LIVE,
    name: Feature.INSTANCE_STOP,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  }
];

@Component({
  selector: 'app-environment-header',
  templateUrl: './environment-header.component.html',
  styleUrl: './environment-header.component.scss',
  standalone: false
})
export class EnvironmentHeaderComponent implements OnInit, OnDestroy, OnChanges {
  private destroyRef = inject(DestroyRef);
  private pollingService = inject(InstancePollingService);
  currentTime: number = Date.now();
  private progressTimer: any;
  lastUpdateTime$: Observable<Date | null>;
  displayTime$: Observable<Date>;
  @Input() data;
  @Input() getBlueprints: any;
  @Input() releasePackage: string;
  @Input() serviceVersions: any;
  @Input() tenantId: any;
  @Input() isAWS: boolean;
  @Input() tenantDetails: any;
  @Input() isHeaderLoading = false;
  @Output() instanceUpdated = new EventEmitter<void>();
  @Output() refreshRequested = new EventEmitter<void>();
  @Input() configVersion: string;
  @Input() sizingApplyInprogress: boolean;
  @Input() isExternalTenant: boolean;
  @Input() tenantOriginChecked: boolean;
  @Input() subscriptionData: any
  private refresInstance!: Subscription;
  private progressOverlayRef: OverlayRef | null = null;

  RouterSegments = RouterSegments;
  DeployStatus = DeployStatus;
  AgentStatus = AgentStatus;
  permissionsMap: { [key: string]: boolean };
  PermissionKeys = PermissionKeys;
  featuresMap: { [key: string]: boolean };
  FeatureKeys = FeatureKeys;
  Constants = Constants;
  DataZone = DataZone;
  instanceClass = DeploymentClass;
  devInstances: any;
  countData: any = {};
  intervalElement: any;
  instanceDetailsError: any;
  showValidationLoader = false;
  activities: any;
  runbookInprogress: any;
  RVTsInprogress: any;
  sanityTestInprogress: any;
  inventoryInprogress: any;
  DBBackupInprogress: any;
  DBResoreInprogress: any;
  AdoCobConfiguring: any;
  CobIsRunning: any;
  JobIsRunning: any;
  inProgressStates:any = [];
  isComponentAvailable = false;
  isActivityInProgress: any;
  latestRecordStatus: boolean;
  initialActivityAPICalled = false;
  private overlayRef: OverlayRef | null = null;
  private closeTimeout: any;
  isRefreshing = false;
  instanceId: any
  bookmark: any;
  isDeploymentAction: boolean | undefined;
  formatAvailabilityState = formatAvailabilityState;
  toUtcString = toUtcString;
  environmentStatusIcon = ENVIRONMENT_STATUS_ICON;
  envProgressStatus = ENV_PROGRESS_STATUS;

  readonly LIFE_CYCLE_STATUS = [DeployStatus.INITIALIZING ,DeployStatus.PROVISIONING, DeployStatus.STOPPING, DeployStatus.STARTING, DeployStatus.CONFIGURING,
    DeployStatus.DELETING, DeployStatus.UPDATING, DeployStatus.RESTORING, DeployStatus.RESIZING
  ];

  readonly AGENT_STATES = [AgentStatus.RUNNING, AgentStatus.STOPPED]
  agentCreationProgress: any;

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZED,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.INITIALIZING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];
  
  readonly INSTANCE_DEPLOYING_STATES_COUNT = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
      DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.INITIALIZED,
      DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
      DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING,];

  readonly INSTANCE_PROGRESS_STATES = [DeployStatus.DEPLOYING, DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.FAILOVER_INPROGRESS, DeployStatus.FALLBACK_INPROGRESS, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.INITIALIZING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.INPROGRESS];
  
  loaderStatus = [
    DeployStatus.DEPLOYING,
    DeployStatus.TERMINATING,
    DeployStatus.CONFIGURING,
    DeployStatus.UPDATING,
    DeployStatus.TESTING,
    DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.STARTING_AGENT,
    DeployStatus.STOPPING_AGENT,
    DeployStatus.STARTING,
    DeployStatus.STOPPING,
    DeployStatus.INPROGRESS
  ];

  statusIcons = {
    deployed: 'check_circle_filled',
    configured: 'check_circle',
    initialized: 'check_circle',
    updated: 'check_circle',
    tested: 'check_circle',
    failed: 'cancel_filled',
    configuration_failed: 'cancel_filled',
    terminated: 'error_outline',
    termination_failed: 'cancel_filled',
    test_failed: 'cancel_filled',
    update_failed: 'cancel_filled',
    stopped: 'error_outline',
    start_failed: 'cancel_filled',
    stop_failed: 'cancel_filled',
    initialize_failed: 'cancel_filled',
    deploying: 'change_circle',
    terminating: 'change_circle',
    configuring: 'change_circle',
    adopting:'change_circle',
    updating: 'change_circle',
    initializing: 'change_circle',
    operation_inprogress: 'change_circle',
    stopping: 'change_circle',
    stopping_agent: 'change_circle',
    starting: 'change_circle',
    starting_agent: 'change_circle',
    testing: 'change_circle',
    fallback_inprogress: 'change_circle',
    failover_inprogress: 'change_circle',
    inprogress: 'change_circle',
  };

  activityList = {
    RUNBOOK_COMPONENT: 'tc-transact-cob-executor-ops-aws',
    RVT_COMPONENT: 'atf',
    SANITYTEST_COMPONENT: 'engine-test-executor',
    INVENTORY_COMPONENT: 'azure-inventory-ops',
    ADOCOB_COMPONENT: 'cob-automation-config'
  }
  switchToNewViewForAzure: boolean;
  blueprintId: any;
  availableStateIcon = AVAILABLE_STATE_ICON;
  latestActivity: any = null;
  activityDetail: any = null;
  isExpanded : boolean = false;
  isStatusPositioned : boolean = false;
  instanceStatus : string;
  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
    private instanceService: InstancesService,
    private permissionsService: PermissionsService,
    private featurePermissionsService: FeaturePermissionsService,
    private router: Router,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private positionBuilder: OverlayPositionBuilder, private activatedRoute: ActivatedRoute,
    private toastrService: CustomToastrService,
    private dbBackupService: DbbackupService,
    private cobService: CobService,
    public schedulerService: SchedulerService,
    public solutionsService: SolutionsService,
    private userService: UserService,
    public activityProgressService: ActivityProgressService,
    private activityService: ActivityService,
    private sidenavService: SidenavService
  ) { }

  ngOnInit(): void {
    this.currentTime = Date.now();
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.pollingService.resetTimer(this.instanceId);
    this.lastUpdateTime$ = this.pollingService.getLastUpdateTime(this.instanceId);

    this.activatedRoute.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      if (params['instanceId'] && params['instanceId'] !== this.instanceId) {
        const oldInstanceId = this.instanceId;
        this.instanceId = params['instanceId'];
        this.pollingService.stopPolling(oldInstanceId);
        this.pollingService.resetTimer(this.instanceId);
        this.lastUpdateTime$ = this.pollingService.getLastUpdateTime(this.instanceId);
      }
    });

    this.displayTime$ = combineLatest([
      this.lastUpdateTime$.pipe(
        startWith(new Date()),
        map(value => value || new Date())
      ),
      interval(1000).pipe(startWith(0))
    ]).pipe(
      map(([lastUpdate]) => lastUpdate),
      takeUntilDestroyed(this.destroyRef)
    );

    this.refresInstance = this.instanceService.refresh$.subscribe(() => {
      this.refreshClick();
    });
    this.getInstanceDetails();
    if (!this.initialActivityAPICalled) {
      this.getInstanceActivityProgress(this.instanceId);
    } else {
      this.intervalElement = setInterval(() => {
      this.getInstanceActivityProgress(this.instanceId);
      }, 60000);
    }
    this.getDBBackupResults();
    this.DBRestoreResults();
    this.COBResults();
    if(this.isAWS) {
      this.jobs();
    }
    this.userService.bookmarkRefresh$.subscribe(() => {
      this.refreshClick();
    });
    this.progressTimer = setInterval(() => {
      this.currentTime = Date.now();
    }, 1000);
    setTimeout(() => {
      this.isStatusPositioned = true;
    }, 1000);
    setTimeout(() => {
      this.isExpanded = true;
    }, 2000);
  }

  ngOnDestroy(): void {
    this.refresInstance.unsubscribe();
    if (this.progressTimer) clearInterval(this.progressTimer);
    this.pollingService.stopPolling(this.instanceId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange && this.instanceId) {
      const newStatus = this.data?.status;
      const oldStatus = changes['data'].previousValue?.status;
      if (newStatus !== oldStatus) {
        this.updatePollingBasedOnStatus();
      }
    }
  }

  private isStatusInProgress(): boolean {
    const isInDeployingStates = this.data.status.toLowerCase().endsWith('ing') || this.data?.lastOperation?.status === DeployStatus.INPROGRESS;
    return isInDeployingStates;
  }

  private updatePollingBasedOnStatus(): void {
    const shouldPoll = this.isStatusInProgress();
    if (!shouldPoll) {
      this.pollingService.stopPolling(this.instanceId);
    } else {
      this.pollingService.startPolling(this.instanceId, true, 15000);
    }
  }

  getDBBackupResults(): void {
    this.dbBackupService.getInstanceDbBackups(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(results => {
      this.DBBackupInprogress = results?.data?.find(item => item.status === 'inprogress');
      this.inProgressStates.push({condition: this.DBBackupInprogress, label: 'INSTANCE_DETAILS.CREATING_DB_BACKUP'});
    },
    (error) => {
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
  }

  DBRestoreResults(): void {
    this.dbBackupService.getInstanceRestores(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(results => {
      this.DBResoreInprogress = results?.data?.find(item => item.status === 'preparing' || item.status === 'promoting');
      this.inProgressStates.push({condition: this.DBResoreInprogress, label: 'INSTANCE_DETAILS.RESTORING_DB'});
    },
    (error) => {
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
  }

  COBResults(): void {
    this.cobService.getCobConfigResults(this.instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(results => {     
      this.CobIsRunning = results?.data?.some(item => item.stages?.some(stage => stage.status === 'started'));
      this.inProgressStates.push({condition: this.CobIsRunning, label: 'INSTANCE_DETAILS.COB_IS_RUNNING'});
    },
    (error) => {
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
  }

  jobs(): void {
    this.schedulerService.getScheduleHistory(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(results => {
      this.JobIsRunning = results?.data?.find(item => item.status === 'running');
      this.inProgressStates.push({condition: this.JobIsRunning, label: 'INSTANCE_DETAILS.COB_IS_RUNNING'});
    },
    (error) => {
      setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
        const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
        this.toastrService.errMessage(message, title);
      }, 500);
    });
  }


  openMenu(button: HTMLElement, menuTemplate: TemplateRef<any>) {
    clearTimeout(this.closeTimeout);
    if (this.progressOverlayRef) {
      this.progressOverlayRef.dispose();
    }
    const positionStrategy = this.positionBuilder
      .flexibleConnectedTo(button)
      .withPositions([{
          originX: 'end',    
          originY: 'bottom',
          overlayX: 'end',   
          overlayY: 'top',
          offsetY: 4      
      }])
      .withPush(false)
    .withViewportMargin(0);
    this.progressOverlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
       width: '350px' 
    });

    const template = new TemplatePortal(menuTemplate, this.viewContainerRef);
    this.progressOverlayRef.attach(template);
    this.progressOverlayRef.overlayElement.addEventListener('mouseleave', () => {
      this.scheduleClose();
    });
  }

  scheduleClose() {
    this.closeTimeout = setTimeout(() => {
      if (this.progressOverlayRef) {
        this.progressOverlayRef.dispose();
        this.progressOverlayRef = null;
      }
    }, 200);
  }

  cancelClose() {
    clearTimeout(this.closeTimeout);
  }

  getBuildVersion(solutionVersionId: any): string {
    const solnVersion = this.serviceVersions?.find(v => v.id === solutionVersionId);
    return solnVersion?.version;
  }

  displayAgentStatus(agentStatus?: any): string {
    if (agentStatus === 'running' || agentStatus === 'stop_failed') {
      return 'Stop';
    } else {
      return 'Start';
    }
  }
  /**
   * Update the instance status when agent start / stop button is clicked
   * Show confirmation popup
   * @param data - instance data
   * @returns 
   */
  changeAgentStatus(data?: Instance): void {
    if ((this.data?.dataZone === DataZone.DEVELOPMENT && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_NONPII]) || (this.data?.dataZone === DataZone.SECURE && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_PII]) ||
      (this.data?.dataZone === DataZone.LIVE && !this.permissionsMap[PermissionKeys.INSTANCE_AGENT_MANAGE_DATAZONE_LIVE]) || this.INSTANCE_DEPLOYING_STATES.includes(this.data?.status)) {
      return;
    }
    if (data.agentStatus === this.AgentStatus.RUNNING || data.agentStatus === this.AgentStatus.STOP_FAILED)
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.AGENT_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.AGENT_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
      if (confirm) {
      this.instanceService.agentStop(data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          complete: () => {
            this.instanceUpdated.emit();
          },
          error: (error) => {
           const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.AGENT_STOP_FAILED'),
                    description: errorMessage,
                  }
               });
          }
        });
      }
    });

    if (data.agentStatus === this.AgentStatus.STOPPED || data.agentStatus === this.AgentStatus.START_FAILED)
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.AGENT_START_TITLE'),
          message: translate('INSTANCE_DETAILS.AGENT_START_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
      this.instanceService.agentStart(data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          complete: () => {
           this.instanceUpdated.emit();
          },
          error: (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.AGENT_START_FAILED'),
                    description: errorMessage,
                  }
               });
          }
        });
      }
    });
  }

  /**
   * Check the deploy instance status and return start or stop
   * @param status - instance status
   * @returns 
   */
  displayInstanceStatus(status?: any): string {
    if (status === DeployStatus.STOPPED || status === DeployStatus.START_FAILED || status === DeployStatus.STOPPING) {
      return 'Start';
    } else {
      return 'Stop';
    }
  }
 /**
  * Validate the status and show the appropriate message
  * @param instance 
  */
  validateEdgenwSharedserv(instance): void {
    this.changeInstanceStatus(instance);
  }

  /**
   * Update the instance status
   * @param instance - selected instane
   */
  changeInstanceStatus(instance?: Instance): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_START_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_START_DESC'),
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          confirmationTitle: translate('INSTANCE_DETAILS.START_INSTNACE_CONFIRMATION'),
          optionSelection: [
            {value: 'now', label: 'Now', selected: true},
            {value: 'schedulelater', label: 'Schedule Later'}
          ]
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if (confirm.value === 'schedulelater') {
              this.scheduleTypes('start', instance?.name, this.getBlueprints?.name);
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.SCHEDULE, RouterSegments.CREATE, RouterSegments.TYPE]);
            }
            if (confirm.value === 'now') {
            this.instanceService.instanceStart(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.instanceUpdated.emit();
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.INSTANCE_START_FAILED'),
                    description: errorMessage,
                  }
               });
              });
            }
          }
      });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          confirmationTitle: translate('INSTANCE_DETAILS.STOP_INSTNACE_CONFIRMATION'),
          optionSelection: [
            {value: 'now', label: 'Now', selected: true},
            {value: 'schedulelater', label: 'Schedule Later', selected: false}
          ]
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if (confirm.value === 'schedulelater') {
              this.scheduleTypes('stop', instance?.name, this.getBlueprints?.name);
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , this.tenantId, RouterSegments.SCHEDULE, RouterSegments.CREATE, RouterSegments.TYPE]);
            }

            if (confirm.value === 'now') {
            this.instanceService.instanceStop(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.instanceUpdated.emit();
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                minHeight: '342px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title: translate('ERROR_DIALOG.INSTANCE_STOP_FAILED'),
                  description: errorMessage
                }
                });
              });
            }
          }
      });
    }
  }

  scheduleTypes(value, instaneName, blueprintName): void {
      let type;
      switch (value) {
        case 'start':
          type = Types.START_INSTANCE;
          break;
        case 'stop':
          type = Types.STOP_INSTANCE;
          break;
        case 'release_package':
          type = Types.APPLY_RELEASE_PACKAGE;
          break;
      }
  
      localStorage.setItem('scheduleInstance', JSON.stringify([{'instanceType': type, 'instanceName': instaneName, 'blueprintName': blueprintName}]) );
    }

  /**
   * Show error message in popup 
   * @param description - description of error message
   */
  openErrorDialog(description): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('BLUEPRINT_SUMMARY.VALIDATION_ERROR'),
        description: translate(description)
      }
    });
    this.showValidationLoader = false;
  }
 
  /**
   * Inprogess status list of instance
   * @param status - the current status of selected instance
   * @returns 
   */
  isInprogressStatus(status): any {
    return this.INSTANCE_DEPLOYING_STATES.includes(status);
  }

  /**
   * Instance activity progress
   * @param instanceId - selected instanceId
   */
  getInstanceActivityProgress(instanceId: string): void {
  this.activityService.getInstanceActivityLogs(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (response) => {
        const total = Number(response?.total ?? 0);
        const limit = Number(response?.limit ?? 10);
        if (total > limit) {
          this.activityService.getInstanceActivityLogs(instanceId,undefined, total)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (response) => this.processActivityResponse(response?.data ?? []),
            error: () => clearInterval(this.intervalElement)
          });
          return;
        } else {
          this.processActivityResponse(response?.data ?? []);
        }
      },
      error: () => clearInterval(this.intervalElement)
    });
}

private processActivityResponse(activities: any[]): void {
  if (!Array.isArray(activities)) {
    this.latestRecordStatus = false;
    return;
  }
  this.activities = activities;
  this.agentCreationProgress = activities.length === 0 && this.data?.status === DeployStatus.DEPLOYING ? DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS : null;
  if (!activities.length) {
    this.latestRecordStatus = false;
    return;
  }
  const sorted = [...activities].sort((a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime());
  const latest = sorted[0];
  this.latestActivity = latest;
  const deploymentActions = ['provision', 'deployment', 'redeploy', 'update','extend', 'initialize', 'deprovision'];
  this.isDeploymentAction = deploymentActions.includes(latest.operation?.toLowerCase());
  this.latestRecordStatus = latest.status === 'inprogress';
  if (this.latestRecordStatus) {
    this.fetchActivityDetail(latest.id);
  }
}

/**
 * Fetches full activity detail by ID.
 * Extracts count, components from the component execution stage when present.
 */
private fetchActivityDetail(activityId: string): void {
  this.activityService.getInstanceActivityLogsById(this.instanceId,activityId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (detail) => {
        this.activityDetail = detail;
        const stages: any[] = detail?.stages ?? [];
        const execStage = stages.find(s => s.type === 'component_execution');
        const components: any[] = execStage?.components ?? [];
        this.isComponentAvailable = components.length > 0;
        if (execStage?.count?.total) {
          this.countData.total       = Number(execStage.count.total);
          this.countData.completed   = Number(execStage.count.completed ?? 0);
          this.countData.skipped     = Number(execStage.count.skipped   ?? 0);
          this.countData.pending     = Number(this.countData.total - (this.countData.completed + this.countData.skipped));
          this.countData.completedPercent = this.countData?.completed !== 0 ? Math.round(((this.countData?.completed + this.countData.skipped) / this.countData.total) * 100) : 0;
        }
        this.runbookInprogress = components.find(
          item => item.name === this.activityList.RUNBOOK_COMPONENT && item.status === 'inprogress'
        );
        this.RVTsInprogress = components.find(
          item => item.name === this.activityList.RVT_COMPONENT && item.status === 'inprogress'
        );
        this.sanityTestInprogress = components.find(
          item => item.name === this.activityList.SANITYTEST_COMPONENT && item.status === 'inprogress'
        );
        this.inventoryInprogress = components.find(
          item => item.name === this.activityList.INVENTORY_COMPONENT && item.status === 'inprogress'
        );
        this.AdoCobConfiguring = components.find(
          item => item.name === this.activityList.ADOCOB_COMPONENT && item.status === 'inprogress'
        );

        this.inProgressStates.push({condition: this.runbookInprogress,    label: 'INSTANCE_DETAILS.CREATING_RUNBOOK'},
          { condition: this.RVTsInprogress,       label: 'INSTANCE_DETAILS.EXCECUTING_RVT'},
          { condition: this.sanityTestInprogress, label: 'INSTANCE_DETAILS.EXCECUTING_SANITY'},
          { condition: this.inventoryInprogress,  label: 'INSTANCE_DETAILS.FETCHING_INVENTORY'},
          { condition: this.AdoCobConfiguring,    label: 'INSTANCE_DETAILS.ADOCOB_CONFIGURING'}
        );
        this.isActivityInProgress = components.filter(c => c.status === 'inprogress').map(c => ({ ...c, action: detail?.operation}));
      },
      error: () => {
      }
    });
}

  /**
   * Opem the agent link in new tab
   * @param suffix - suffix of instance
   */
  agentLink(suffix, type) {
    this.dialog.open(RedirectionDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          redirectTitle: this.isAWS ? translate('BLUEPRINT_SUMMARY.AWS_PLATFORM') : translate('BLUEPRINT_SUMMARY.AZURE_PLATFORM'),
          redirectMsg: this.isAWS ? translate('BLUEPRINT_SUMMARY.AWS_CLOUD_WATCH_LOG') : translate('BLUEPRINT_SUMMARY.AZURE_AGENT_CONTAINER'),
          proceedButtonText: translate('BUTTONS.PROCEED')
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
      if (confirm) {
        if (this.isAWS) {
          const url = `https://${this.data?.primaryRegion}.console.aws.amazon.com/cloudwatch/home?region=${this.data?.primaryRegion}#logsV2:log-groups/log-group`;
          window.open(url, '_blank');
        } else if (this.subscriptionData) {
          const subscriptionId = this.subscriptionData?.filter(item => item.dataZone === this.data?.dataZone)[0]?.azureDetails?.subscriptionId;
          const resourceGroup = (this.isExternalTenant && type !== 'tsi' && type !== 'tss')? `${suffix}-agent-engine` : `${suffix}-agent`;
          const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource/subscriptions/${subscriptionId}/resourceGroups/${resourceGroup}/providers/Microsoft.ContainerInstance/containerGroups/Agent%20Container/containers`;
          window.open(url, '_blank');
        }
      }
    });
  }

  viewErrors(instanceId): void {
    if (this.data?.errors?.length > 0) {
      let dialogData = {
        title: translate('NOTIFICATIONS.DEPLOYMENT_FAILED'),
        descriptionError: this.data?.errors,
        subtitle: instanceId?.name
      };
      if (this.data?.status === DeployStatus.TERMINATION_FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.TERMINATION_FAILED');
      } else if (this.data?.status === DeployStatus.CONFIGURATION_FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.CONFIGURATION_FAILED');
      } else if (this.data?.status === DeployStatus.TEST_FAILED) {
        dialogData.title = translate('CONFIGURATIONS.STATE.TEST_FAILED');
      } else if (this.data?.status === DeployStatus.FAILED) {
        dialogData.title = translate('BLUEPRINT_SUMMARY.FAILED');
      } else {
        dialogData.title = translate('NOTIFICATIONS.DEPLOYMENT_FAILED');
      }
      dialogData.descriptionError = this.data?.errors;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: dialogData
      });
    }
  } 

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.getBookmarks(data);
          this.data.solution = data;
          this.isRefreshing = false;
          this.instanceStatus = this.data?.lastOperation?.executionPhase === DeployStatus.ABORTING ? this.data?.lastOperation?.executionPhase + ' ' + this.data?.lastOperation?.type : this.data?.status === DeployStatus.INPROGRESS ? translate(this.activityProgressService.getEnvironmentStatus(this.data?.lastOperation?.type,this.data?.status)) : this.data?.status;
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
          this.isRefreshing = false;
        }, 500);
      });
  }

  refreshClick(): void {
    if (this.isRefreshing) {
      return;
    }
    this.isRefreshing = true;
    this.inProgressStates = [];
    setTimeout(() => {
      this.getInstanceDetails();
      this.getInstanceActivityProgress(this.instanceId);
      this.getDBBackupResults();
      this.DBRestoreResults();
      this.COBResults();
      if(this.isAWS) {
        this.jobs();
      }
      this.pollingService.updateLastRefreshTime(this.instanceId);
      this.isRefreshing = false;
    }, 1000);
    this.refreshRequested.emit();
  }

  isAllowed(component: any): boolean {
    const exclude = Object.values(this.activityList);
    return !exclude.includes(component.name);    
  }

  /* onSwitchToOld(): void {
    this.switchToNewViewForAzure = false;
    this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.blueprintId, 'instance', this.instanceId]);
    // localStorage.setItem('switchToNewViewForAzure', JSON.stringify(this.switchToNewViewForAzure));
  } */

  get activeInProgressStates() {
    return this.inProgressStates.filter(state => state.condition);
  }

  getBackRoute(): any[] {
  const isFromCU = this.activatedRoute.snapshot.queryParams['fromCU'] === "true";
  const isFromDR = this.activatedRoute.snapshot.queryParams['fromDR'] === "true";
  return [
    '/',
    this.authService.principal.provider,
    RouterSegments.TENANT,
    this.tenantId,
    ...(isFromCU ? [RouterSegments.CONTINUOUS_UPDATE] : []),
    ...(isFromDR ? [RouterSegments.DISASTER_RECOVERY] : []),
    RouterSegments.BLUEPRINTS,
    this.getBlueprints.id
  ];
}

/**
   * Add / remove bookmark for the selected instance
  * @param data - the selected instance
*/
addRemoveBookmark(data): void {
  const userId = this.authService?.principal?.attributes?.email;
  setTimeout(() => {
    if (!data.bookmarked) {
      const bookmarkObj: any = {
        instanceId: data.id,
        instanceName: data.name,
        blueprintId: data.blueprintId,
        tenantId: data.tenantId,
        userId: userId
      };

      this.userService.addBookmark(bookmarkObj).subscribe( items => {
        data.bookmarked = true;
        this.getBookmarks(data);
      });
    } else {
      this.userService.deleteBookmark(data?.bookmarkedId).subscribe( items => {
        data.bookmarked = false;
      });
    }
    }, 50);
  }

 /**
 * Get bookmarks for the logged-in user and updates the instance.
 * @param data - Instance object to enrich with bookmark details
 */
  getBookmarks(data): void {
    const userId = this.authService?.principal?.attributes?.email;
    if (!userId) {
      return;
    }
    setTimeout(() => {
      this.userService.getBookmarks(userId).subscribe(items => {
      this.bookmark = items;
      const matchedBookmark = this.bookmark?.find(
        item => item.instanceId === data?.id
      );
      data.bookmarked = !!matchedBookmark;
      data.bookmarkedId = matchedBookmark?.id || null;
    });
    }, 2000);

  }

  /**
   * Shows a confirmation dialog to abort the action.
   * If confirmed, calls the abort API and refreshes the data.
   */
  abortEnvironmentAction(): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.ABORT'),
        message: translate('INSTANCE_DETAILS.ABORT_MSG', {activity: this.data.lastOperation.type}),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    }).afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if(confirm) {
        this.instanceService.putInstanceAbort(this.instanceId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          this.refreshClick();
        },
        (error) => {
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
      }
    })
  }

  // open activity details page
  openActivityDetails(){
    const data = {
      activityDetail: this.activityDetail,
      instance: this.data
    }
    this.sidenavService.openInRightSidenav(EnvironmentActivityDetails, data, "activityDetails")
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((detail) => {
      this.activityDetail = detail;
      const stages: any[] = detail?.stages ?? [];
      const execStage = stages.find(s => s.type === 'component_execution');
      const components: any[] = execStage?.components ?? [];
      this.isComponentAvailable = components.length > 0;
      if (execStage?.count?.total) {
          this.countData.total       = Number(execStage.count.total);
          this.countData.completed   = Number(execStage.count.completed ?? 0);
          this.countData.skipped     = Number(execStage.count.skipped   ?? 0);
          this.countData.pending     = Number(this.countData.total - (this.countData.completed + this.countData.skipped));
          this.countData.completedPercent = this.countData?.completed !== 0 ? Math.round(((this.countData?.completed + this.countData.skipped) / this.countData.total) * 100) : 0;
      }
    });
  }


}
